// copied from apps/checkout-b2b/src/constants.ts
export const MIN_CONSUMPTION = 1;
export const MAX_CONSUMPTION = 2_000_000_000;
export const MIN_METERS = 1;

//# sourceMappingURL=constants.js.map